/**
 * 注册路由
 * 2017-12-6
 */
"use strict";
angular.module("pgcAuthenticationRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("register.pgcauthentication",{
        url:"/pgcauthentication?userType",
        views:{
            "main@register": {
                templateUrl: "./login/register/pgcAuthentication/pgcAuthentication_tpl.html",
                controller: "pgcAuthenticationCtrl"
            }
        }
    }).state("register.pgcauthentication.personal",{
        url:"/personal?type",
        views:{
            "main@register": {
                templateUrl: "./login/register/pgcAuthentication/personal/personal_tpl.html",
                controller: "personalCtrl"
            }
        }
    }).state("register.pgcauthentication.enterprise",{
        url:"/enterprise?type",
        views:{
            "main@register": {
                templateUrl: "./login/register/pgcAuthentication/enterprise/enterprise_tpl.html",
                controller: "enterpriseCtrl"
            }
        }
    });
}]);